import { Link } from "react-router-dom";
import { Collapse } from "antd";
import Svg from "../Svg";
// import "./header.scss"
import router from "../../utils/router";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import BulletMenuMobile from "./BulletMenuMobile";
import { useMemo, useState } from "react";

const { Panel } = Collapse;

const ResponsiveMenuContent = ({ setMobileMenuProfileDrawer }) => {

    const dispatch = useDispatch();
    // const isLoggedIn = useSelector((state) => state.auth.userToken);
    const descriptionLinks = router().links.map((i, index) => ({ ...i, svg: i.name, id: index }));
    const BranchWithShowType = useSelector((state) => state.business?.BranchWithShowType);
    const home = useSelector((state) => state.view.home);
    const business = useSelector((state) => state.business);
    const [isOpenCollapse, setIsOpenCollapse] = useState(false);

    const toggleCollapse = () => {
        setIsOpenCollapse(!isOpenCollapse);
    };

    const insuranceLinks = useMemo(() => {
        let branches = [];
        BranchWithShowType?.map((item) => {
            let rec = router().links.filter((link) => { return item.Branch === link?.name })[0];
            const desc = descriptionLinks.filter(item => item.name === rec?.name)[0]
            if (desc)
                branches.push(desc)
        })
        return branches
    }, [business])

    const items = [
        {
            key: '1',
            label: <span className="">
                <Svg name="menu-insurances" className="fill-header-color" />
                <span className="pr-2 font-weight-bold">بیمه‌ها</span>
            </span>,
           
            children: <span>
                {insuranceLinks?.length && insuranceLinks.map((link, index) => (
                    <li onClick={() => {
                        setMobileMenuProfileDrawer(false)
                        // dispatch(cleanAllInsuranceItems())
                    }
                    } key={index} className="nav-items mb-1">
                        <a href={window.location.origin + link.path}>
                            {link.insuranceFaName}
                        </a>
                    </li>
                )
                )}
            </span>,
        }
    ]

   

    return (
        // <div className="fullmenu">
        <ul className="nav">
            <li className="pb-3 mb-1" onClick={() => setMobileMenuProfileDrawer(false)}>
                <ArrowRightOutlined style={{ cursor: 'pointer' }} />
            </li>
            {/* {!isLoggedIn && <li className="nav-item">
                <Link data-tracking-id="login-register" to="https://bimeh.com/auth/login" className="nav-link">
                    <Svg name="user" className="circle-icon path-fill" />
                    <div>ورود | ثبت نام</div>
                </Link>
            </li>} */}
            <li className="nav-titles mt-1 mb-1">
            <Collapse
                        expandIcon={({ isActive }) => isActive ? <Svg name="expand-icon-mobile" className="fill-darker-surface-color rotate-180" /> : <Svg name="expand-icon-mobile" className="fill-darker-surface-color rotate-0" />}
                        ghost
                        items={items}
                        // headerClassName="d-flex justify-content-between w-80"
                        detailClassName="mt-1"
                        bordered={false} defaultActiveKey={["0"]}/>
                {/* <Collapse
                    title={<span className="header-color d-flex align-items-center">
                        <Svg name="menu-insurances" className="fill-header-color" />
                        <span className="pr-2 font-weight-bold">بیمه‌ها</span>
                    </span>}
                    icon={isOpenCollapse ? <Svg name="arrowDown" className='rotate180' /> : <Svg name="arrowDown" />}
                    headerClassName="d-flex justify-content-between w-80"
                    open={!isOpenCollapse}
                    toggleCollapse={toggleCollapse}
                    detailClassName="mt-1"
                >
                    {insuranceLinks?.map((link, index) => (
                        <div onClick={() => setMobileMenuProfileDrawer(false)} key={index} className="nav-items mb-1">
                            <a href={link.path}>
                                {link.insuranceFaName}
                            </a>
                        </div>
                    )
                    )}
                </Collapse> */}
            </li>
            <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles mt-1 mb-1">
                <a data-tracking-id="insurance-blog" target="_blank"
                    href="https://bimeh.com/companies" className="nav-link">
                    <Svg name="bookTwoTone" className="fill-header-color" />
                    <span className="header-color">
                        شرکت‌های بیمه
                    </span>
                </a>
            </li>
            <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles mt-1 mb-1">
                <a target="_blank"
                    href="https://bimeh.com/marketers/">
                    <Svg name="menu-promotor" className="fill-header-color" />
                    <span style={{ fontWeight: 550 }} className='header-color' >
                        کسب درآمد کنید
                    </span>
                </a>
            </li>

            <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles mt-1 mb-1">
                <a data-tracking-id="track-order" href="https://bimeh.com/TrackingRequest" className="nav-link">
                    <Svg name="menu-tracking" className="fill-header-color" />
                    <span className="header-color">
                        پیگیری خرید
                    </span>
                </a>
            </li>
            {/* <li className="nav-titles mt-1 mb-1">
                <Link to="/about" className="nav-link" onClick={() => setMobileMenuProfileDrawer(false)}>
                    <Svg name="infoHexagonTwoTone" className="fill-header-color" />
                    <span className="header-color">

                        درباره ما
                    </span>
                </Link>
            </li> */}

        </ul>
        // </div>
    );
};
export default ResponsiveMenuContent;
